import { jsx as u } from "react/jsx-runtime";
import { c as k } from "../../clsx-OuTLNxxd.js";
import { useLocation as h, NavLink as g } from "react-router";
import '../../assets/MenuLink.css';const i = {
  "menu-link": "_menu-link_8gjhh_1",
  "menu-link--active": "_menu-link--active_8gjhh_8"
}, v = ({ overrideDefault: o, ...t }) => {
  const s = h(), e = (n) => n.replace(/s$/, ""), l = (n) => {
    const a = s.pathname.split("/").filter(Boolean), c = n.split("/").filter(Boolean).slice(-1)[0], r = e(c);
    return a.some((m) => e(m) === r);
  };
  return /* @__PURE__ */ u(
    g,
    {
      ...t,
      className: ({ isActive: n }) => k(i["menu-link"], {
        [i["menu-link--active"]]: o ? "" : n || l(t.to)
      })
    }
  );
};
export {
  v as MenuLink
};
//# sourceMappingURL=MenuLink.js.map
